import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../Navbar/Navbar';
import BottomBar from '../BottomBar/BottomBar';
import logo from '../../assets/logo.png';
import { blogPostingSchema, breadcrumbSchema, organizationSchema, websiteSchema } from '../../utils/structuredData';

class BlogDetails extends Component {
    state = {
        post: null,
        prevPost: null,
        nextPost: null,
        loading: true
    }

    componentDidMount() {
        const slug = this.props.match.params.slug;
        fetch(`${process.env.REACT_APP_CMS_URL}/wp-json/wp/v2/posts?slug=${slug}&_embed`)
            .then(res => res.json())
            .then(data => {
                if (data.length > 0) {
                    const post = data[0];
                    this.setState({ post, loading: false });
                    this.fetchAdjacentPosts(post.date);
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ loading: false });
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.slug !== this.props.match.params.slug) {
            this.setState({ post: null, prevPost: null, nextPost: null, loading: true });
            const slug = this.props.match.params.slug;
            fetch(`${process.env.REACT_APP_CMS_URL}/wp-json/wp/v2/posts?slug=${slug}&_embed`)
                .then(res => res.json())
                .then(data => {
                    if (data.length > 0) {
                        const post = data[0];
                        this.setState({ post, loading: false });
                        this.fetchAdjacentPosts(post.date);
                    } else {
                        this.setState({ loading: false });
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.setState({ loading: false });
                });
        }
    }

    fetchAdjacentPosts(date) {
        const base = `${process.env.REACT_APP_CMS_URL}/wp-json/wp/v2/posts?per_page=1&_fields=id,slug,title`;
        Promise.all([
            fetch(`${base}&before=${date}&orderby=date&order=desc`).then(r => r.json()),
            fetch(`${base}&after=${date}&orderby=date&order=asc`).then(r => r.json()),
        ]).then(([prev, next]) => {
            this.setState({
                prevPost: prev.length > 0 ? prev[0] : null,
                nextPost: next.length > 0 ? next[0] : null,
            });
        }).catch(() => {});
    }

    render() {
        if (this.state.loading) {
            return (
                <div>
                    <Navbar imageData={logo} />
                    <div style={{ textAlign: 'center', padding: '100px' }}>Loading blog...</div>
                    <div className="footer-static"><BottomBar /></div>
                </div>
            );
        }

        if (!this.state.post) {
            return (
                <div>
                    <Navbar imageData={logo} />
                    <div style={{ textAlign: 'center', padding: '100px' }}>Blog post not found.</div>
                    <div className="footer-static"><BottomBar /></div>
                </div>
            );
        }

        const { post, prevPost, nextPost } = this.state;
        const description = (post.excerpt?.rendered || '')
            .replace(/<[^>]*>/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .substring(0, 160);
        const canonical = `https://moneymonkapp.in/blog/${post.slug}`;
        const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
        const author = post._embedded?.author?.[0]?.name;
        const date = new Date(post.date).toLocaleDateString('en-IN', {
            year: 'numeric', month: 'long', day: 'numeric'
        });

        return (
            <div>
                <Helmet>
                    <title>{post.title.rendered} | MoneyMonk</title>
                    <meta name="description" content={description} />
                    <link rel="canonical" href={canonical} />
                    <script type="application/ld+json">{JSON.stringify(blogPostingSchema(post))}</script>
                    <script type="application/ld+json">{JSON.stringify(breadcrumbSchema([
                        { name: 'Home', url: 'https://moneymonkapp.in' },
                        { name: 'Blog', url: 'https://moneymonkapp.in/blog' },
                        { name: post.title.rendered.replace(/<[^>]*>/g, ''), url: canonical }
                    ]))}</script>
                    <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
                    <script type="application/ld+json">{JSON.stringify(websiteSchema())}</script>
                </Helmet>
                <Navbar imageData={logo} />
                <div className="container" style={{ paddingTop: '100px', paddingBottom: '60px' }}>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <h1
                                style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '16px' }}
                                dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                            />
                            <div style={{ display: 'flex', gap: '16px', color: '#666', fontSize: '14px', marginBottom: '24px' }}>
                                {author && <span>By <strong>{author}</strong></span>}
                                <span>{date}</span>
                            </div>
                            {featuredImage && (
                                <img
                                    src={featuredImage}
                                    alt={post.title.rendered}
                                    style={{ width: '100%', borderRadius: '8px', marginBottom: '32px' }}
                                />
                            )}
                            <div
                                className="blog-post-content"
                                dangerouslySetInnerHTML={{ __html: post.content.rendered }}
                            />

                            {/* Previous / Next navigation */}
                            {(prevPost || nextPost) && (
                                <div className="blog-post-navigation">
                                    <div className="blog-nav-prev">
                                        {prevPost && (
                                            <a href={`/blog/${prevPost.slug}`}>
                                                <span className="blog-nav-label">← Previous</span>
                                                <span className="blog-nav-title"
                                                    dangerouslySetInnerHTML={{ __html: prevPost.title.rendered }}
                                                />
                                            </a>
                                        )}
                                    </div>
                                    <div className="blog-nav-next">
                                        {nextPost && (
                                            <a href={`/blog/${nextPost.slug}`}>
                                                <span className="blog-nav-label">Next →</span>
                                                <span className="blog-nav-title"
                                                    dangerouslySetInnerHTML={{ __html: nextPost.title.rendered }}
                                                />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="footer-static">
                    <BottomBar />
                </div>
            </div>
        );
    }
}

export default BlogDetails;
